export default __webpack_public_path__ + "static/media/AntheasHouse.13615945.jpg";